import { OVERLAP_CHECKING_STEP, Platform } from './const';

export const injectScript = (url, onLoad) => {
  const script = document.createElement('script');
  script.src = url;
  script.async = true;
  script.defer = true;

  onLoad && (script.onload = onLoad);

  document.body.appendChild(script);
}

export const createAdSlot = (content = []) => {
  const div = document.createElement('div');
  div.className = CSS_PREFIX + 'slot';
  div.append(...content);

  return div;
}

export const createVideoSlot = () => {
  const video = document.createElement('video');
  video.muted = true;
  video.autoplay = false;
  video.volume = 0;

  video.setAttribute('muted', 'muted');
  video.setAttribute('playsinline', 'playsinline');
  video.setAttribute('playsinline', 'true');
  video.setAttribute('webkit-playsinline', 'true');

  return video;
}

export const createUIElement = (tag, className, listeners = {}, children = "") => {
  const elem = document.createElement(tag);
  elem.className = className;
  elem.innerHTML = children;

  Object.entries(listeners).forEach(([event, listener]) => elem.addEventListener(event, listener));

  return elem;
}

export const getRandomString = () => Math.random().toString(36).replace(/[^a-z]+/g, '');

export const getRandomInteger = (min, max) => Math.floor(min + Math.random() * (max + 1 - min));

export const log = (...args) => console.log(...args);

export const isMobile = (maxDesktopWidth) => window.matchMedia(`(min-width: ${maxDesktopWidth}px)`).matches;

export const detectMobile = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];
  
  return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
  });
}

export const isIOS = () => {
  return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

// export const isIOS = () => {
//   const toMatch = [
//     /iPhone/i,
//     /iPad/i,
//     /iPod/i,
//   ];
//
//   return toMatch.some((toMatchItem) => {
//     return navigator.userAgent.match(toMatchItem);
//   });
// }

export const clearAllTimers = (timerList) => {
  Object.keys(timerList).forEach((timer) => {
    if (timerList[timer]) {
      // console.log(`killing timeout ${timer} with id ${timerList[timer]}`);
      clearTimeout(timerList[timer]);
      timerList[timer] = null;
    }
  });
};

export const getElementViewabilityPercent = (element, currentAdPlatform) => {
  if (!element) return 0;
  const rect = element.getBoundingClientRect();

  const getElementVisibilityState = (el) => {
    const computedStyles = window.getComputedStyle(el, null);

    return parseFloat(computedStyles.opacity) >= 0.75 && computedStyles.visibility !== "hidden";
  }

  const getElementInViewPercent = (rectPrimaryValue, rectSide, rectOppositeSide, screenPrimaryValue) => {
    if (rectSide >= 0 && rectOppositeSide <= screenPrimaryValue) {
      return 100;
    }

    const offset = rectSide < 0 ? rectPrimaryValue / rectOppositeSide : rectPrimaryValue / (screenPrimaryValue - rectSide);

    return 100 / offset;
  }

  const getNotOvarlappedVisibilitySquare = (el) => {
    const checkedElements = [];
    let totalOverlappingSquare = 0;

    for (let i = rect.left > 0 ? rect.left : 0; i < Math.abs(rect.left + rect.width); i += OVERLAP_CHECKING_STEP) {
      for (let j = rect.top > 0 ? rect.top : 0; j < Math.abs(rect.top + rect.height); j += OVERLAP_CHECKING_STEP) {
        let elementOnPoint = document.elementsFromPoint(i, j)[0];

        if (elementOnPoint && elementOnPoint.shadowRoot) {
          elementOnPoint = elementOnPoint.shadowRoot.elementsFromPoint(i, j)[0];
        }

        if (elementOnPoint && !el.contains(elementOnPoint) && !checkedElements.includes(elementOnPoint)) {
          checkedElements.push(elementOnPoint);
          const elementOnPointRect = elementOnPoint.getBoundingClientRect();
          if (!elementOnPointRect) continue;

          const leftSide = elementOnPointRect.left < rect.left ? rect.left : elementOnPointRect.left;
          const rightSide = elementOnPointRect.right > rect.right ? rect.right : elementOnPointRect.right;
          const topSide = elementOnPointRect.top < rect.top ? rect.top : elementOnPointRect.top;
          const bottomSide = elementOnPointRect.bottom > rect.bottom ? rect.bottom : elementOnPointRect.bottom;

          const left = leftSide > 0 ? leftSide : 0;
          const right = rightSide < window.innerWidth ? rightSide : window.innerWidth;
          const top = topSide > 0 ? topSide : 0;
          const bottom = bottomSide < window.innerHeight ? bottomSide : window.innerHeight;

          const width = right - left;
          const height = bottom - top;

          const square = width * height;

          totalOverlappingSquare += square;
        }
      }
    }

    return totalOverlappingSquare;
  }

  if (element.offsetWidth === 0 || element.offsetHeight === 0) return 0;

  let currentElement = element;
  while (currentElement.parentElement) {
    if (getElementVisibilityState(currentElement)) {
      currentElement = currentElement.parentElement;
    } else {
      return 0;
    }
  }

  const verticalPerc = getElementInViewPercent(element, rect.height, rect.top, rect.bottom, window.innerHeight);
  const horizontalPerc = getElementInViewPercent(element, rect.width, rect.left, rect.right, window.innerWidth);

  const inViewPercent = verticalPerc / 100 * horizontalPerc;

  const notOverlappedSquare = getNotOvarlappedVisibilitySquare(element);
  const inViewSquare = rect.width * rect.height / 100 * inViewPercent;
  const notOverlappedPerc = Math.abs((inViewSquare - notOverlappedSquare) / (inViewSquare / 100));

  return Math.round(inViewPercent / 100 * (currentAdPlatform === Platform.YANDEX_ADS_SDK ? 100 : Math.max(1, notOverlappedPerc))); // 100 - 
}

export const createMobileConsole = () => {
  const con = document.createElement('div');

  con.style.cssText = 'position: fixed; top: 0; left: 0; width: 100vw; height: 300px; overflow: auto; background-color: rgba(255, 255, 255, .85); z-index: 9999; font-size: 14px!important; font-family: monospace!important;';
  document.body.appendChild(con);

  return con;
}

export const getCookie = (cookiename) => {
  var name = cookiename + "=";
  var cookiearray = document.cookie.split(';');
  for (var i = 0; i < cookiearray.length; i++) {
    var cookie = cookiearray[i];
    while (cookie.charAt(0) == ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return "";
};

export const createUserSync = (iframeURL, scriptURL, { gdpr, consent }, callback) => {
  if (!iframeURL && !scriptURL) return;

  let iframeSource = '', scriptSource = '';

  if (iframeURL) iframeSource = iframeURL.replace('(gdpr)', gdpr).replace('(gdpr_consent)', consent);
  if (scriptURL) scriptSource = scriptURL.replace('(gdpr)', gdpr).replace('(gdpr_consent)', consent);

  if (iframeSource) {
    const iframe = document.createElement('iframe');
    iframe.src = iframeSource;
    iframe.style.display = 'none';

    document.body.appendChild(iframe);
  }

  if (scriptSource) {
    injectScript(scriptSource, callback);
  }
}

export const resetActiveSlots = (parent, includeContent = false) => {
  const activeSlots = parent.querySelectorAll('.active');

  activeSlots.forEach((slot) => {
    if (!includeContent && slot.classList.contains(CSS_PREFIX + 'content')) return;
    
    slot.classList.remove('active');
    slot.style.cssText = '';
  });
}

export const replaceBaseURLMacroses = (url, { tid, aid, sid, zone, videoid, uuid }) => {
  return url.replace(/\(sid\)/ig, sid)
    .replace(/\(tid\)/ig, tid)
    .replace(/\(aid\)/ig, aid)
    .replace(/\(video_id\)/ig, videoid)
    .replace(/\(uuid\)/ig, uuid)
    .replace(/\(encoded_page_url\)/ig, encodeURIComponent(window.top.location.href))
    .replace(/\(zone\)/ig, zone);
}

export const getSlotSizes = (slot, isMobileDevice) => {
  let width = 0, height = 0;
  
  const cssWidth = window.getComputedStyle(slot.parentElement).getPropertyValue(`${CSS_PREFIX}player-width`);
  const cssHeight = window.getComputedStyle(slot.parentElement).getPropertyValue(`${CSS_PREFIX}player-height`);

  if (isMobileDevice) {
    width = window.top.innerWidth || cssWidth;
    height = width / 16 * 9;
  } else {
    width = slot.clientWidth || window.screen.width; // cssWidth;
    height = width / 16 * 9; // slot.clientHeight || // cssHeight;
  }

  return { width, height };
}

export const logOnServerDebugInfo = (body, version = -1) => fetch(`https://ru.viadata.store/logs/?tid=${version}`, { // https://e.displayfly.com/log/?tid=${tid}
  method: 'POST',
  body,
});

export const truncate = (element, options) => {
  options = {
    lines: options?.lines || 2,
    truncationChar: options?.truncationChar || '…',
    splitOnChars: options?.splitOnChars || ['.', '-', '–', '—', ' '],
  }

  let originalText = element.innerHTML
  let truncatedText = originalText
  let lineHeight = getStyleProp(element, 'line-height')
  lineHeight = lineHeight === 'normal' ? parseInt(getStyleProp(element, 'font-size')) * 1.2 : parseInt(lineHeight)
  let maxHeight = lineHeight * options.lines

  function getStyleProp (element, propName) {
    return window.getComputedStyle(element, null).getPropertyValue(propName)
  }

  function applyEllipsis (target, string) {
    target.nodeValue = string + options.truncationChar
  }

  let splitOnChars = options.splitOnChars.slice(0)
  let splitChar = splitOnChars[0]
  let chunks
  let lastChunk

  function getLastChild (elem) {
    if (elem.lastChild.children && elem.lastChild.children.length > 0) {
      return getLastChild(Array.prototype.slice.call(elem.children).pop())
    } else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue === '' || elem.lastChild.nodeValue === options.truncationChar) {
      elem.lastChild.parentNode.removeChild(elem.lastChild)
      return getLastChild(elem)
    } else {
      return elem.lastChild
    }
  }

  function run (target) {
    if (!maxHeight) return

    function reset () {
      splitOnChars = options.splitOnChars.slice(0)
      splitChar = splitOnChars[0]
      chunks = null
      lastChunk = null
    }

    const nodeValue = target.nodeValue.replace(options.truncationChar, '')

    if (!chunks) {
      if (splitOnChars.length > 0) {
        splitChar = splitOnChars.shift()
      } else {
        splitChar = ''
      }

      chunks = nodeValue.split(splitChar)
    }

    if (chunks.length > 1) {
      lastChunk = chunks.pop()

      applyEllipsis(target, chunks.join(splitChar))
    } else {
      chunks = null
    }

    if (chunks) {
      if (element.clientHeight <= maxHeight) {
        if (splitOnChars.length >= 0 && splitChar !== '') {
          applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk)
          chunks = null
        } else {
          return element.innerHTML
        }
      }
    } else {
      if (splitChar === '') {
        applyEllipsis(target, '')
        target = getLastChild(element)

        reset()
      }
    }
    return run(target)
  }

  if (maxHeight < element.clientHeight) {
    truncatedText = run(getLastChild(element))
  }

  return {
    originalText,
    truncatedText,
  }
}

export const createCSSVar = (parent, name, value) => {
  return parent.style.setProperty(`--${CSS_PREFIX}${name}`, value);
}

export const convertBufferToString = (buffer) => Object.values(buffer).reduce((result, buff) => result += String.fromCharCode(buff), "");

export const MD5 = (d) => {var r = M(V(Y(X(d),8*d.length)));return r.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}

export const getRemainingTime = (deadline) => {
  const currentTime = new Date().getTime()
  return deadline - currentTime
}

export const startSkipTimeout = ({ seconds, onFinish, circleContent, circleProgressBar }) => {
  const endProgressDashoffset = 124
  const endTime = new Date().getTime() + (seconds) * 1000

  function showTime () {
    const remainingTime = getRemainingTime(endTime)
    const secondsLeft = (remainingTime / 1000) % 60

    if (secondsLeft >= 0) {
      circleContent.innerHTML = secondsLeft.toFixed(0)
    }

    const progressValue = endProgressDashoffset - (endProgressDashoffset * (secondsLeft / seconds))
    circleProgressBar.style.strokeDashoffset = progressValue <= endProgressDashoffset ? -progressValue : -endProgressDashoffset

    if (remainingTime > 500) {
      requestAnimationFrame(showTime)
    } else {
      onFinish();
    }
  }

  requestAnimationFrame(showTime)
}

export const getTopURL = () => {
  var topLinkInfo = {};

  try {
    // Only for same origins
    topLinkInfo.topHref = top.location.href;
  }
  // Security exception: different origins
  catch (error) {
    try {
      var ancestorOrigins = window.location.ancestorOrigins;
      // Firefox doesn't support window.location.ancestorOrigins
      if (ancestorOrigins) {
        topLinkInfo.parentsDomains = [];
        for (var i = 0; i < ancestorOrigins.length; i++) {
          topLinkInfo.parentsDomains.unshift(ancestorOrigins[i]);
        }
      }

      // Sometimes referrer refers to the parent URL (but not always,
      // e.g. after iframe redirects).
      var bottomW = window;
      var topW = window.parent;
      topLinkInfo.parentsReferrers = [];
      // In case of empty referrers
      topLinkInfo.parentsHrefs = [];

      while (topW !== bottomW) {
        topLinkInfo.parentsReferrers.unshift(bottomW.document.referrer);
        topLinkInfo.parentsHrefs.unshift(bottomW.location.href);
        bottomW = bottomW.parent;
        topW = topW.parent;
      }
    } catch (error) {/* Permission denied to access a cross-origin frame */}
  }
  // console.log('topLinkInfo', topLinkInfo);

  return topLinkInfo.topHref ? topLinkInfo.topHref : (topLinkInfo.parentsDomains[0] || window.location.href);
}
